import type { ReactNode } from 'react';

import DisplayOn from './DisplayOn';

type Props = {
  children: ReactNode;
};

const DisplayDownLg = ({ children }: Props) => (
  <DisplayOn mode="down" defaultState={true}>
    {children}
  </DisplayOn>
);

DisplayDownLg.displayName = 'DisplayDownLg';

export default DisplayDownLg;
